import React, { PureComponent } from 'react';
import { Route } from 'react-router-dom';

import ListingDetailComponent from './listing-detail-component';
import BookingOptionsComponent from '../dashboard/bookings/booking-options-component';
import BookingPricingComponent from '../dashboard/bookings/booking-overview-component';

class RouteTable extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (<div>
      <Route exact path="/listing/:id" component={ListingDetailComponent} />
      <Route path="/listing/:id/booking-options" component={BookingOptionsComponent} />
      <Route path="/listing/:id/booking-pricing" component={BookingPricingComponent} />
    </div>);

  }
}

export default RouteTable;
